import { useEffect } from 'react'

// Meta (Facebook) Business Manager domain verification token.
export const FACEBOOK_DOMAIN_VERIFICATION = 'wmiyglwvda84iemzzgkg722anxnbzn'

// Adds <meta name="facebook-domain-verification" content="..."> to <head>.
//
// NOTE: Meta's crawler prefers the tag to be present in the served HTML
// source. This project has no editable index.html, so the tag is injected on
// mount. If verification doesn't complete, add the same tag to the published
// site's head via the editor's Publish > metadata settings.
export function useFacebookDomainVerification() {
  useEffect(() => {
    const selector = 'meta[name="facebook-domain-verification"]'
    let tag = document.querySelector(selector) as HTMLMetaElement | null
    if (!tag) {
      tag = document.createElement('meta')
      tag.setAttribute('name', 'facebook-domain-verification')
      document.head.appendChild(tag)
    }
    tag.setAttribute('content', FACEBOOK_DOMAIN_VERIFICATION)
  }, [])
}
